"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NUMBER = exports.DATE_SIGNED = exports.DATE = exports.UNVALIDATED_INITIAL_SIGNATURE = exports.UNVALIDATED_SIGNATURE = exports.INITIAL_SIGNATURE = exports.SIGNATURE = exports.CMB = exports.RDO = exports.CHK = exports.TXT = void 0;
var TXT = 'TXT';
exports.TXT = TXT;
var CHK = 'CHK'; // export const BTN = 'BTN';  // We dont support buttons

exports.CHK = CHK;
var RDO = 'RDO';
exports.RDO = RDO;
var CMB = 'CMB'; // Custom Fields

exports.CMB = CMB;
var SIGNATURE = 'SIGNATURE';
exports.SIGNATURE = SIGNATURE;
var INITIAL_SIGNATURE = 'INITIAL_SIGNATURE';
exports.INITIAL_SIGNATURE = INITIAL_SIGNATURE;
var UNVALIDATED_SIGNATURE = 'UNVALIDATED_SIGNATURE';
exports.UNVALIDATED_SIGNATURE = UNVALIDATED_SIGNATURE;
var UNVALIDATED_INITIAL_SIGNATURE = 'UNVALIDATED_INITIAL_SIGNATURE';
exports.UNVALIDATED_INITIAL_SIGNATURE = UNVALIDATED_INITIAL_SIGNATURE;
var DATE = 'DATE';
exports.DATE = DATE;
var DATE_SIGNED = 'DATE_SIGNED';
exports.DATE_SIGNED = DATE_SIGNED;
var NUMBER = 'NUMBER';
exports.NUMBER = NUMBER;